import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Foto1 from './images/foto1.png';
import Foto2 from './images/foto2.jpeg';
import Foto3 from './images/foto3.jpeg';
import Foto4 from './images/foto4.png';
import Foto5 from './images/Foto5.jpg';


// import Foto6 from './images/Foto6.png'

function Inicio() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true, // ← flechas activadas
    pauseOnHover: true,
  };

  return (
    <div>
      <h1>Bienvenido al Municipio de tu ya sabes jajaj</h1>
      <p>Este es el contenido de la página de inicio.</p>
      <div className="slider-container">
        <Slider {...settings}>
          {[Foto1, Foto2, Foto3, Foto4, Foto5].map((foto, idx) => (
      <div key={idx}>
        <img src={foto} alt={`Foto ${idx + 1}`} className="carrusel-imagen" />
      </div>
        ))}
        </Slider>
      </div>

      <h1>Bienvenido al Municipio de tu ya sabes jajaj</h1>
      <p>Este es el contenido de la página de inicio.</p>

      <div className="photo-container">
        <img src={Foto1} alt="Descripción de la Foto 1" className="inicio-photo" />
        
      </div>
    </div>
  );
}

export default Inicio;
